var $ = require('jquery');
 
module.exports = {
    data: function() {
      return {
        islogin:false,
        effect:'back',
        user:'',
        pagename:'',
        showsub:true,
        token:localStorage['token'],
      }
    },
    // computed:{
    //   issubnav:function{}
    // },
    components:{
      navbar:require('./components/navbar.vue'),
      search:require('./components/search.vue'),
      sidebar:require('./components/sidebar.vue'),
      tooltip:require('vue-strap').tooltip,
      subnav:require('./components/subnav.vue')
    },
    created:function(){
    },
    //组件事件通信
    //子组件可以通过 this.$dispatch('confirmCallback',this); 来触发父组件events中声明的事件
    events:{
    },
    methods:{
      appclick:function(){
          this.$broadcast('bodyclick')

      },
      nonBreaking:function(){
        console.log('nonBreaking');
      },
      showToast:function(){
        //直接设置，默认2.5秒后自动消失
        this.toast.content = 'toast  2.5s...';
        //如果同时设置多个，则只会显示最后一个
        // this.toast.content = 'toast  2.6s...';
        // this.toast.content = 'toast  2.7s...';
        // this.toast.content = 'toast  2.8s...';
      },
      //自定义时长
      customShowToast:function(){
        this.toast = { content : '自定义时长4s...', timer : 4000};
      },
      //按需加载
      splitting:function(){
        //加载完毕后添加到map中
        var _this = this;
        require.ensure(['./views/splitting.vue'], function(require) {
          var splitting = require('./views/splitting.vue');
          _this.$route.router.map({
            '/splitting_view':{
              name:'splitting',
              component: splitting
            }
          });

          //加载完毕后再跳转
          _this.$route.router.go({name:'splitting'});

        });

        //如果使用bundle-loader  会报错
        // var load = require("bundle!./views/splitting.vue");
        // load(function(file){
        //   _this.$route.router.map({
        //     '/splitting_view':{
        //     name:'splitting',
        //     component: splitting
        //     }
        //   });
        //   //加载完毕后再跳转
        //   _this.$route.router.go({name:'splitting'});
        // });

      }
    },
    ready:function(){
      //this.$set('as',new AwesomeSheet({ touchDismiss: false }));
      // === Resize window related === //
      var ul = $('#sidebar > ul');
      $(window).resize(function()
      {
        if($(window).width() > 479)
        {
          ul.css({'display':'block'});  
          $('#content-header .btn-group').css({width:'auto'});    
        }
        if($(window).width() < 479)
        {
          ul.css({'display':'none'});
         // fix_position();
        }
        if($(window).width() > 768)
        {
          $('#user-nav > ul').css({width:'auto',margin:'0'});
          $('#content-header .btn-group').css({width:'auto'});
        }
      });
      
      if($(window).width() < 468)
      {
        ul.css({'display':'none'});
        //fix_position();
      }
      
      if($(window).width() > 479)
      {
         $('#content-header .btn-group').css({width:'auto'});
        ul.css({'display':'block'});
      }
      
    },
    
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/selector.js?type=script&index=0!./src/app.vue
// module id = 34
// module chunks = 0